import * as React from 'react';
import '../../../productAccessPanel/ProductAccessPanel.css';
import { AppStore } from '../../../../../stores';
import { inject, observer } from 'mobx-react';
import ProductService from '../../../../../services/ProductService';
import { FilePicker } from '../../../../../mindjuiceApp/UI/filePicker/FilePicker';
import AdminService from '../../../../../services/AdminService';
import DocumentPicker from '../../../../../mindjuiceApp/UI/documentPicker/DocumentPicker';
import AdminModuleDocument from '../../../../../mindjuiceApp/UI/adminModuleDocument/AdminModuleDocument';
import { IModuleDocument } from '../../../../../interfaces/IModuleDocument';
import MindPaperEditPanel from '../../../productEditPanel/mindPaperEditPanel/MindPaperEditPanel';
import { IAPivot } from '../../../../../mindjuiceApp/UI/pivot/Pivot';
import { Pivot } from '../../../../../mindjuiceApp/pivot/Pivot';

export interface IProps {
  teamId: string;
  selectedLanguage;
  appStore?: AppStore;
}

export interface IState {
  availablemindPapers: any[];
  selectedWorkbookType: string;
  selectedLanguage;
}

@inject('appStore')
@observer
export default class TeamProductModuleEditPanel extends React.Component<IProps, IState> {

  private lastEditIndex?: number = undefined;

  constructor(props) {
    super(props);
    this.state = {
      availablemindPapers: [],
      selectedWorkbookType: "mindPaper",
      selectedLanguage: props.selectedLanguage ?? "danish"
    }
  }

  public componentDidMount(): void {
    this.checkPanelOpened();
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.teamId !== undefined && props.teamId !== this.props.teamId) {
      this.getMindPapers();
    }
    if (props.selectedLanguage !== this.props.selectedLanguage) {
      this.setState({
        selectedLanguage: props.selectedLanguage ?? this.state.selectedLanguage
      });
    }
  }

  public componentDidUpdate(): void {
    this.checkPanelOpened();
  }

  private checkPanelOpened(): void {
    const editIndex = this.props.appStore?.teamProductModuleIndesToEdit;
    if (editIndex !== undefined && editIndex !== this.lastEditIndex) {
      this.lastEditIndex = editIndex;
      this.ensureProgramModulesUpToDate();
    } else if (editIndex === undefined) {
      this.lastEditIndex = undefined;
    }
  }

  private ensureProgramModulesUpToDate(): void {
    if (!this.props.appStore?.teamToEdit) {
      return;
    }
    const productModules = this.props.appStore.selectedProduct?.modules ?? [];
    if (!this.props.appStore.teamToEdit.modules) {
      this.props.appStore.teamToEdit.modules = [];
    }
    const teamModules = this.props.appStore.teamToEdit.modules;
    for (let i = 0; i < productModules.length; i++) {
      const productModule = productModules[i];
      const alreadyAdded = teamModules.some((teamModule) => teamModule.id === productModule.id);
      if (!alreadyAdded) {
        teamModules.push({ id: productModule.id, fromprogram: true });
      }
    }
  }

  private getMindPapers(selectedObjectId?: string): void {
    ProductService.getMindPapers().then((mindPapers: any[]) => {
      if (this.props.appStore) {
        this.props.appStore!.mindPapers = mindPapers;
        if (selectedObjectId && this.props.appStore!.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]) {
          this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamProductModuleIndesToEdit!].mindPaperId = selectedObjectId;
        }
      }
      this.loadMindPapers();
    });
  }

  private loadMindPapers(): void {
    const availablemindPapers: JSX.Element[] = [];
    availablemindPapers.push(
      <option value="all">Vælg MindPaper</option>
    );
    this.setState({ availablemindPapers });
    if (this.props.appStore?.mindPapers) {
      this.props.appStore!.mindPapers.forEach((mindPaper: any) => {
        if (this.props.appStore?.teamProductModuleIndesToEdit !== undefined && this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit]?.mindPaperId === mindPaper.objectId) {
          availablemindPapers.push(
            <option value={mindPaper.objectId} selected>{mindPaper.title}</option>
          );
        } else {
          availablemindPapers.push(
            <option value={mindPaper.objectId}>{mindPaper.title}</option>
          );
        }
      });
      this.setState({ availablemindPapers });
      this.forceUpdate();
    }
  }

  private array_move(arr, old_index, new_index): any[] {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  render() {
    const documents: JSX.Element[] = [];
    const module = this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1];
    if (module?.documents && module.documents.length > 0) {
      module.documents.forEach((documentId: string, index) => {
        documents.push(
          <AdminModuleDocument
            id={documentId}
            isMobile={this.props.appStore?.isMobile || false}
            disableMoveDown={(module.documents?.length ?? 0) - 1 === index}
            disableMoveUp={index === 0}
            selectedLanguage={this.state.selectedLanguage}
            onDelete={() => {
              if (module?.documents) {
                module.documents.splice(index, 1);
              }
            }}
            onMoveUp={() => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]?.documents && module?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamProductModuleIndesToEdit!].documents = this.array_move(module.documents, index, index - 1);
              }
            }}
            onMoveDown={() => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]?.documents && module?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamProductModuleIndesToEdit!].documents = this.array_move(module.documents, index, index + 1);
              }
            }}
            onUpdate={(document: any) => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamProductModuleIndesToEdit!].documents![index] = document;
              }
            }}
          />
        );
      });
    }
    return (
      <div>
        <div
          className="productModuleEditPanelWrapper"
          style={{
            visibility: this.props.appStore?.teamProductModuleIndesToEdit !== undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            if (this.props.appStore) {
              (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
              this.props.appStore!.isAddingModule = false;
            }
          }}
        />
        <div
          className="productModuleEditPanel"
          style={{
            right: this.props.appStore?.teamProductModuleIndesToEdit !== undefined ? 0 : -620
          }}
        >
          <Pivot
            highlightColor="#b362fa"
            textColor="#333333"
            items={[
              {
                key: "danish",
                text: window.loc?.strings?.Danish || "Danish",
              },
              {
                key: "english",
                text: window.loc?.strings?.English || "English",
              }
            ]}
            style={{
              fontSize: "14px",
              textTransform: "uppercase",
              width: "100%"
            }}
            selectedKey={this.state.selectedLanguage}
            select={(selectedLanguage: string) => {
              this.setState({ selectedLanguage });
            }}
          />
          {this.props.appStore?.teamProductModuleIndesToEdit !== undefined && module &&
            <div>
            <div className="inputFieldLabel" style={{ width: "fit-content", clear: "both", float: "left" }}>Udgivelsesdato</div>
              <input
                type="date"
                value={module?.releaseDate ? new Date(module.releaseDate ?? "").toISOString().split("T")[0] : ""}
                onChange={(event: any) => {

                    const productModuleId = this.props.appStore?.selectedProduct?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]?.id ?? "";
                  if (this.props.appStore && this.props.appStore!.teamToEdit?.modules && module) {
                    module.releaseDate = event.target.value;
                  } else {
                    if (this.props.appStore && this.props.appStore!.teamToEdit && this.props.appStore!.teamToEdit.modules === undefined) {
                      this.props.appStore!.teamToEdit.modules = [];
                      this.props.appStore!.teamToEdit.modules.push({
                        id: productModuleId,
                        releaseDate: event.target.value
                      });
                    } else {
                      this.props.appStore!.teamToEdit!.modules!.push({
                        id: productModuleId,
                        releaseDate: event.target.value
                      });
                    }
                  }
                }}
                style={{
                  width: "calc(100% - 10px)"
                }}
              />
              <h3>Dokumenter specifikt til dette hold</h3>
              {documents}
              <DocumentPicker
                document={{
                  product: this.props.appStore?.teamToEdit?.productId,
                  team: this.props.appStore?.teamToEdit?.team,
                  type: "teamModuleDocument"
                }}
                selectedLanguage={this.state.selectedLanguage}
                isMobile={this.props.appStore?.isMobile || false}
                onChange={(document: IModuleDocument) => {
                  if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamProductModuleIndesToEdit ?? -1]) {
                    const currentModule = this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamProductModuleIndesToEdit!];
                    if (!currentModule.documents) {
                      currentModule.documents = [];
                    }
                    if (document?.objectId) {
                      currentModule.documents.push(document.objectId);
                    }
                  }
                }}
              />
              {/* Save */}
              <button
                style={{
                  clear: "both"
                }}
                onClick={() => {
                  if (this.props.appStore?.teamToEdit && this.props.appStore!.teamToEdit.objectId !== undefined) {
                    ProductService.updateProduct(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  } else if (this.props.appStore?.teamToEdit) {
                    ProductService.createProduct(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  }
                }}
              >
                {this.props.appStore?.isAddingModule ? "Opret" : "Opdater"}
              </button>

              {/* Save and notify
              <button
                onClick={() => {
                  if (this.props.appStore?.teamToEdit && this.props.appStore!.teamToEdit.objectId !== undefined) {
                    ProductService.updateTeam(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        // this.props.appStore!.notificationToEdit = {
                        //   objectId: "new",
                        //   sendToAll: false,
                        //   title: `${window.loc?.strings?.thereIsNewContentFor || 'There is new content for'} ${this.props.appStore!.selectedProduct?.title || ''}`,
                        //   text: `${window.loc?.strings?.thereIsNewContentFor || 'There is new content for'} ${module?.title || ''}`,
                        //   linkText: window.loc?.strings?.open || 'Open',
                        //   link: location.href,
                        //   receivers: [{
                        //     product: this.props.appStore!.selectedProduct,
                        //     selected: false,
                        //     teams: [{ team: this.props.appStore!.teamToEdit, selected: true }]
                        //   }]
                        // };
                        (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  }
                }}
              >
                {this.props.appStore?.isAddingModule ? "Opret og send besked til deltagere" : "Opdater og send besked til deltagere"}
              </button> */}

              <button
                style={{
                  marginLeft: 10
                }}
                onClick={() => {
                  if (this.props.appStore) {
                    if (this.props.appStore!.isAddingModule && this.props.appStore!.teamToEdit?.modules && this.props.appStore!.teamProductModuleIndesToEdit !== undefined) {
                      this.props.appStore!.teamToEdit.modules.splice(this.props.appStore!.teamProductModuleIndesToEdit, 1);
                    }
                    (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
                    this.props.appStore!.isAddingModule = false;
                  }
                }}
              >
                Annuller
              </button>
              <button
                onClick={() => {
                  if (this.props.appStore?.teamToEdit?.modules && this.props.appStore!.teamProductModuleIndesToEdit !== undefined) {
                    this.props.appStore!.teamToEdit.modules.splice(this.props.appStore!.teamProductModuleIndesToEdit, 1);
                    (this.props.appStore as any).teamProductModuleIndesToEdit = undefined;
                    this.props.appStore!.isAddingModule = false;
                  }
                }}
                style={{
                  backgroundColor: "gray",
                  marginLeft: 10
                }}
              >
                Slet
              </button>
            </div>
          }
        </div>
        {this.props.appStore?.teamToEdit && this.props.appStore?.mindPaperToEdit && !this.props.appStore!.mindPaperToEdit.document &&
          <MindPaperEditPanel
            reloadMindPapers={(selectedId?: string) => {
              if (this.props.appStore) {
                (this.props.appStore as any).mindPaperToEdit = undefined;
                this.getMindPapers(selectedId);
              }
            }}
          />
        }
      </div>
    );
  }
}